import { axios } from "../helpers"

export default {
    state: {
        typesData: [],
        typesLoadStatus: 0,
    },
    getters: {
        getTypesData(state) {
            return state.typesData
        },
        getTypesLoadStatus(state) {
            return state.typesLoadStatus
        },
    },
    mutations: {
        setTypesData(state, typesData) {
            state.typesData = typesData;
        },
        setTypesLoadStatus(state, status) {
            state.typesLoadStatus = status;
        },
    },
    actions: {
        loadTypesData({commit}) {
            commit('setTypesLoadStatus', 1);

            axios
                .get('/types')
                    .then(response => {
                        commit('setTypesData', response.data);
                        commit('setTypesLoadStatus', 2);
                    }).catch(() => {
                        commit('setTypesData', {});
                        commit('setTypesLoadStatus', 3);
                    });
        },
    }
}
